import { createGlobalStyle, keyframes } from 'styled-components';

import { ThemeProp } from './Themes';

export const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const GlobalStyles = createGlobalStyle<ThemeProp>`
  :root {
    --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);
    --rsbs-bg: ${({ theme }: ThemeProp): string => theme.colors.greyscale.c600};
    --rsbs-handle-bg: ${({ theme }: ThemeProp): string => theme.colors.greyscale.c400};
  }

  body {
    margin: 0; 
    padding: 0
  }
  
  h4 {
    font-weight: 600;
    margin: 0;
    line-height: 24px;
    font-size: 16px;
  }
  
  .rjsf-form {
    width: 100%;
  }
  
  input:-webkit-autofill, input:-webkit-autofill:focus {
      transition: background-color 600000s 0s, color 600000s 0s;
  }

  input[data-autocompleted] {
      background-color: transparent !important;
  }

  .nextui-popover-content-container {
    border-radius: ${({ theme }: ThemeProp): string => theme.borderRadius};
  }

  .nextui-popover-content {
    .nextui-table-container {
      box-shadow: none;
    }
  }

  .tooltip-wrapper {
    padding: 0.5rem;
    background: ${(props: ThemeProp) => props.theme.colors.black};
    border-radius: 0.5rem;
    border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
    max-width: 15rem;
    color: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
    font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
    font-family: ${(props: ThemeProp) => props.theme.fonts.primary};

    .nextui-tooltip-arrow{
      background: ${(props: ThemeProp) => props.theme.colors.black};
    }
  }

  .tooltip-wrapper-shared-org {
    transform: translateY(-0.25rem);
  }

  .nextui-tooltip-button {
    width: unset;
  }

  .nextui-modal {
    background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  }

  //Toasts
  .toastOrganizationInviteSuccess {
    div[role=status] {
      margin: 0
    }
    background: ${(props: ThemeProp) => props.theme.colors.greyscale.c300};
    color: ${(props: ThemeProp) => props.theme.colors.white};
  }

  button[class*='-isFocusVisible-true'] {
    box-shadow: none;
  }
`;

export default GlobalStyles;
